<template>
  <div class="toiletuse flex-center k_b1">
    <i class="k_top_left"></i>
    <i class="k_top_right"></i>
    <i class="k_bottom_left"></i>
    <i class="k_bottom_rigth"></i>
    <span class="paperExtractorStatus">
      <i
        class="iconfont icon-chouzhi2"
        v-if="terminalPrompt"
        @click="dateWeek()"
        :style="paperStyle"
      >
        <span class="paperText">{{ terminalPrompt }}</span>
      </i>
    </span>
    <div
      v-if="id"
      class="dwre"
      :style="{
        backgroundImage:
          'url(' + `${global.imgSrc}img/toiletMap/${imgs[id].name}.png` + ')'
      }"
    >
      <ul
        class="flex"
        :class="`dwab${id}_${num}`"
        v-for="(i, num) in imgs[id].man"
      >
        <li
          class="flex-center imgsize"
          :class="`imgsize${id}`"
          v-show="item.isOccupy"
          :style="{
            backgroundImage: `url(${imgMale})`
          }"
          v-for="(item, index) in toiletUse1"
          v-if="isView(imgs[id].man, num, index)"
          :key="index"
        >
          <!-- <div class="imgtext">{{ item.num }}</div> -->
        </li>
      </ul>
      <ul
        class="flex"
        :class="`dwab${id}_2_${num}`"
        v-for="(i, num) in imgs[id].woman"
      >
        <li
          class="flex-center imgsize"
          :class="[`imgsize${id}_2`]"
          v-for="(item, index) in toiletUse2"
          v-if="isView(imgs[id].woman, num, index)"
          v-show="item.isOccupy"
          :style="{
            backgroundImage: `url(${imgFamale})`
          }"
          :key="index"
        >
          <!-- <div class="imgtext">{{ item.num }}</div> -->
        </li>
      </ul>
      <div
        v-show="toiletUse3.length > 0 && item.isOccupy"
        class="flex-center imgsize imgsize_3"
        v-for="(item, index) in toiletUse3"
        :key="index"
        :style="{
          backgroundImage: `url(${imgAccessibility})`
        }"
        :class="`imgsize${id}_3`"
      >
        <!-- <div class="imgtext">{{ item.num }}</div> -->
      </div>
    </div>
  </div>
</template>
<script>
import dayjs from "dayjs";
import bubblEchart from "@/components/html/bubblEchartcontainer.vue";

export default {
  name: "toiletOccupy",
  visible: false,
  props: {
    id: {
      type: Number,
      default: 1
    }
  },
  components: {
    "bubble-chart": bubblEchart
  },
  data() {
    return {
      imgs: {
        // name:图片名称，man：男厕位数量数组，woman：女厕位数量数组，three：第三卫生间（0：存在，1不存在）
        // 厕位数量数组表示全部厕位循环的截止下标，如：man: [3]，表示循环到第3次截止，woman: [3, 5]，表示循环到3次截止和第5次截止
        1: { name: "fhl", man: [5], woman: [3, 4], three: [1] },
        2: { name: "sfq", man: [3], woman: [4], three: [0] },
        3: { name: "stgc", man: [3], woman: [3, 5], three: [1] },
        4: { name: "csq", man: [3], woman: [3], three: [1] },
        5: { name: "slq", man: [4], woman: [4], three: [1] },
        6: { name: "hx", man: [4], woman: [4], three: [0] },
        7: { name: "sx", man: [2], woman: [6, 9], three: [1] },
        8: { name: "mwl", man: [3], woman: [2, 5], three: [1] },
        9: { name: "lzq", man: [4], woman: [3, 7], three: [1] },
        10: { name: "hcdl", man: [3], woman: [4], three: [1] },
        11: { name: "fhs", man: [4], woman: [4, 8, 9], three: [0] },
        12: { name: "yhq", man: [3], woman: [3, 5], three: [1] },
        16: { name: "lzb", man: [3], woman: [6, 9], three: [1] },
        17: { name: "fhl2", man: [8], woman: [5, 12], three: [1] },
        21: { name: "stbwg", man: [3], woman: [2, 5], three: [1] },
        22: { name: "bh", man: [3], woman: [3, 6], three: [1] },
        23: { name: "hwl", man: [1, 5], woman: [3, 7], three: [0] },
        25: { name: "yql", man: [4], woman: [4], three: [1] },
        26: { name: "hzl", man: [6], woman: [4, 10], three: [0] },
        28: { name: "ybdd", man: [3], woman: [3], three: [1] },
        30: { name: "ls", man: [3], woman: [2], three: [1] },
        36: { name: "gzq", man: [2], woman: [3,6], three: [1] },
        37: { name: "sfqn", man: [2], woman: [3,6], three: [1] },
        39: { name: "xcyz", man: [], woman: [], three: [] }
      },
      toiletUse1: [],
      toiletUse2: [],
      toiletUse3: [],
      interval: null,
      titleLogo: "icon-chouzhi2",
      toileTakeParpe: {},
      paperStyle: {},
      terminalPrompt: null,
      start_Time: "",
      end_Time: "",
      imgMale: require("@/img/toiletMAP/male.png"),
      imgFamale: require("@/img/toiletMAP/famale.png"),
      imgAccessibility: require("@/img/toiletMAP/accessibility.png"),
      accessibility: 0,
    };
  },
  methods: {
    getToiletOccupancy() {
      //坑位使用数据
      this.get("toiletOccupancy/list", { toiletId: this.id }).then(res => {
        this.toiletUse1 = res.data.rows.filter(elm => {
          // 判断潮汐厕位状态
          if(elm.sex == 4 && this.accessibility == 1) {
            return true
          }
          return elm.sex == 1;
        });
        this.toiletUse2 = res.data.rows.filter(elm => {
          // 判断潮汐厕位状态
          if(elm.sex == 4 && this.accessibility == 2) {
            return true
          }
          return elm.sex == 2;
        });

        this.toiletUse3 = res.data.rows.filter(elm => {
          return elm.sex == 3;
        }) || [];
        this.$emit("getOccupyData", {data1: this.toiletUse1, data2: this.toiletUse2, data3: this.toiletUse3});
      });
    },

    //卷纸使用情况
    //1.接口连接
    getToileTakePaper() {
      this.get("/outPaper/status", { toilet_id: this.id }).then(res => {
        this.terminalPrompt = null;
        if(res.data.data.length > 0) {
          this.getToileState(res.data.data[0]);
        }
      });
    },
    //2.设备状态
    getToileState(data) {
      if (data) {
        if (data.state === 1) {
          this.terminalPrompt = "在线";
          this.paperStyle = { color: "#00ff00", "font-size": "25px" };
        } else if (data.state === 2) {
          this.terminalPrompt = "离线";
          this.paperStyle = { color: "#8c8c8c", "font-size": "25px" };
        } else if (data.state === 3) {
          this.terminalPrompt = "缺纸";
          this.paperStyle = {
            color: "#ff0000",
            "font-size": "25px",
            animation: "blinks-data-v-f93ae2e4 2s infinite"
          };
        }
      }
    },
    //3.获取当前周给子组件传参
    dateWeek() {
      this.start_Time = dayjs()
        .startOf("week")
        .add(0, "day")
        .format("YYYY-MM-DD");
      this.end_Time = dayjs()
        .endOf("week")
        .add(0, "day")
        .format("YYYY-MM-DD");
      this.$router.push({
        path: "/toileUseThePaper",
        query: {
          equipmentId: this.id,
          startDate: this.start_Time,
          endDate: this.end_Time
        }
      });
    },
    isView(item, num, index) {
      //判断是否显示
      //item:厕位个数数组
      //num:厕位个数数组下标
      //index:全部厕位的循环下标，与上面的num不同
      if (item.length == 1) {
        return index < item[num];
      } else {
        if (num > 0) {
          return index >= item[num - 1] && index < item[num];
        }
        return index < item[num];
      }
    }
  },
  mounted() {
    this.getToileTakePaper();
    this.$store.dispatch("gettolietyw", this.id);
    if (this.interval) clearInterval(this.interval);
    this.interval = setInterval(() => {
      this.getToiletOccupancy();
    }, 2000);
  },
  beforeDestroy() {
    clearInterval(this.interval);
    this.interval = null;
  },
  watch: {
    id: function(newVal, oldVal) {
      this.$store.dispatch("gettolietyw", newVal);
      this.getToiletOccupancy();
      this.getToileTakePaper();
    }
  }
};
</script>

<style lang="less" scoped>
.toiletuse {
  height: 100%;
  width: 100%;
  display: flex;
  position: relative;
  box-shadow: rgb(198 227 255) 0 0 18px inset;

  .dwre {
    position: relative;
    background-repeat: no-repeat;
    width: 883px;
    height: 612px;
    background-size: 883px 612px;
    background-attachment: local;
    overflow: auto;

    .imgsize {
      width: 64px;
      height: 100%;
      background-repeat: no-repeat;
      background-size: 100% 100%;
    }

    .imgsize_3 {
      width: 63px;
      height: 80px;
    }

    .imgtext {
      font-size: 25px;
      font-family: "nmb";
    }

    .dwab1_0 {
      position: absolute;
      width: 318px;
      height: 80px;
      top: 85px;
      left: 315px;
      transform: rotate(148deg);

      .imgsize1 {
        transform: rotate(-148deg);
      }
    }

    .dwab1_2_0 {
      position: absolute;
      width: 187px;
      height: 80px;
      top: 137px;
      left: 492px;
      transform: rotate(-32deg);

      .imgsize1_2 {
        transform: rotate(32deg);
      }
    }
    .dwab1_2_1 {
      position: absolute;
      width: 187px;
      height: 80px;
      top: 235px;
      left: 435px;
      transform: rotate(-32deg);

      .imgsize1_2 {
        transform: rotate(32deg);
      }
    }

    .imgsize1_3 {
      position: absolute;
      top: 310px;
      left: 240px;
    }
    .dwab2_0 {
      position: absolute;
      width: 252px;
      height: 80px;
      top: 106px;
      left: 310px;
      transform: rotate(-32deg);
      .imgsize2 {
        transform: rotate(32deg);
        margin-right: 20px;
      }
    }
    .dwab2_2_0 {
      position: absolute;
      width: 335px;
      height: 80px;
      top: 178px;
      left: 342px;
      transform: rotate(-32deg);

      .imgsize2_2 {
        transform: rotate(32deg);
        margin-right: 20px;
      }
    }
    .dwab3_0 {
      position: absolute;
      width: 192px;
      height: 80px;
      top: 65px;
      left: 370px;
      transform: rotate(148deg);
      .imgsize3 {
        transform: rotate(-148deg);
      }
    }
    .dwab3_2_0 {
      position: absolute;
      width: 216px;
      height: 80px;
      top: 140px;
      left: 425px;
      transform: rotate(-32deg);
      .imgsize3_2 {
        transform: rotate(32deg);
      }
    }
    .dwab3_2_1 {
      position: absolute;
      width: 130px;
      height: 80px;
      top: 200px;
      left: 670px;
      transform: rotate(148deg);
      .imgsize3_2 {
        transform: rotate(-148deg);
      }
    }
    .imgsize3_3 {
      position: absolute;
      top: 380px;
      left: 405px;
    }
    .dwab4_0 {
      position: absolute;
      width: 192px;
      height: 80px;
      top: 60px;
      left: 272px;
      transform: rotate(32deg);
      .imgsize4 {
        transform: rotate(-32deg);
      }
    }
    .dwab4_2_0 {
      position: absolute;
      width: 192px;
      height: 80px;
      top: 130px;
      left: 223px;
      transform: rotate(-148deg);
      .imgsize4_2 {
        transform: rotate(148deg);
      }
    }
    .imgsize4_3 {
      position: absolute;
      top: 364px;
      left: 290px;
      /* transform:rotate(-32deg); */
    }
    .dwab5_0 {
      position: absolute;
      width: 256px;
      height: 80px;
      top: 141px;
      left: 415px;
      transform: rotate(148deg);
      .imgsize5 {
        transform: rotate(-148deg);
      }
    }
    .dwab5_2_0 {
      position: absolute;
      width: 256px;
      height: 80px;
      top: 90px;
      left: 328px;
      transform: rotate(148deg);
      .imgsize5_2 {
        transform: rotate(-148deg);
      }
    }
    .imgsize5_3 {
      position: absolute;
      top: 384px;
      left: 310px;
    }
    .dwab6_0 {
      position: absolute;
      width: 256px;
      height: 80px;
      top: 320px;
      left: 545px;
      transform: rotate(32deg);
      .imgsize6 {
        transform: rotate(-32deg);
      }
    }
    .dwab6_2_0 {
      position: absolute;
      width: 256px;
      height: 80px;
      top: 55px;
      left: 110px;
      transform: rotate(32deg);
      .imgsize6_2 {
        transform: rotate(-32deg);
      }
    }
    .imgsize6_3 {
      position: absolute;
      top: 191px;
      left: 375px;
    }

    .dwab7_0 {
      position: absolute;
      width: 100px;
      height: 67px;
      top: 275px;
      left: 625px;
      transform: rotate(32deg);
      .imgsize7 {
        transform: rotate(-32deg);
      }
    }
    .dwab7_2_0 {
      position: absolute;
      width: 300px;
      height: 67px;
      top: 350px;
      left: 250px;
      transform: rotate(32deg);
      .imgsize7_2 {
        transform: rotate(-32deg);
      }
    }
    .dwab7_2_1 {
      position: absolute;
      width: 145px;
      height: 67px;
      top: 300px;
      left: 515px;
      transform: rotate(32deg);
      .imgsize7_2 {
        transform: rotate(-32deg);
      }
    }
    .imgsize7_3 {
      position: absolute;
      top: 58px;
      left: 200px;
    }
    .dwab8_0 {
      position: absolute;
      width: 192px;
      height: 80px;
      top: 80px;
      left: 355px;
      transform: rotate(148deg);
      .imgsize8 {
        transform: rotate(-148deg);
      }
    }
    .dwab8_2_0 {
      position: absolute;
      width: 125px;
      height: 80px;
      top: 175px;
      left: 530px;
      transform: rotate(-32deg);
      .imgsize8_2 {
        transform: rotate(32deg);
      }
    }
    .dwab8_2_1 {
      position: absolute;
      width: 180px;
      height: 80px;
      top: 255px;
      left: 640px;
      transform: rotate(148deg);
      .imgsize8_2 {
        transform: rotate(-148deg);
      }
    }
    .imgsize8_3 {
      position: absolute;
      top: 204px;
      left: 112px;
    }
    .dwab9_0 {
      position: absolute;
      width: 285px;
      height: 80px;
      top: 105px;
      left: 285px;
      transform: rotate(-32deg);
      .imgsize9 {
        transform: rotate(32deg);
        margin-right: 8px;
      }
    }
    .dwab9_2_0 {
      position: absolute;
      width: 205px;
      height: 80px;
      top: 230px;
      left: 580px;
      transform: rotate(-32deg);
      .imgsize9_2 {
        transform: rotate(32deg);
      }
    }
    .dwab9_2_1 {
      position: absolute;
      width: 275px;
      height: 80px;
      top: 140px;
      left: 405px;
      transform: rotate(148deg);
      .imgsize9_2 {
        transform: rotate(-148deg);
      }
    }
    .imgsize9_3 {
      position: absolute;
      top: 400px;
      left: 372px;
    }
    .dwab10_0 {
      position: absolute;
      width: 200px;
      height: 80px;
      top: 45px;
      left: 245px;
      transform: rotate(148deg);
      .imgsize10 {
        transform: rotate(-148deg);
      }
    }
    .dwab10_2_0 {
      position: absolute;
      width: 268px;
      height: 80px;
      top: 215px;
      left: 365px;
      transform: rotate(-32deg);
      .imgsize10_2 {
        transform: rotate(32deg);
      }
    }
    .imgsize10_3 {
      position: absolute;
      top: 176px;
      left: 102px;
    }
    .dwab11_0 {
      position: absolute;
      width: 220px;
      height: 68px;
      top: 35px;
      left: 350px;
      transform: rotate(29deg);
      .imgsize11 {
        transform: rotate(-29deg);
      }
    }
    .dwab11_2_0 {
      position: absolute;
      width: 200px;
      height: 64px;
      top: 275px;
      left: 415px;
      transform: rotate(-35deg);
      .imgsize11_2 {
        width: 50px;
        height: 64px;
        transform: rotate(35deg);
      }
    }
    .dwab11_2_1 {
      position: absolute;
      width: 200px;
      height: 64px;
      top: 300px;
      left: 540px;
      transform: rotate(145deg);
      .imgsize11_2 {
        width: 50px;
        height: 64px;
        transform: rotate(-145deg);
      }
    }
    .dwab11_2_2 {
      position: absolute;
      width: 55px;
      height: 64px;
      top: 445px;
      left: 400px;
      transform: rotate(-32deg);
      .imgsize11_2 {
        width: 50px;
        height: 64px;
        transform: rotate(32deg);
      }
    }
    // 云鸿桥公厕
    .dwab12_0 {
      position: absolute;
      width: 192px;
      height: 80px;
      top: 170px;
      left: 555px;
      transform: rotate(29deg);
      .imgsize12 {
        transform: rotate(-29deg);
      }
    }
    .dwab12_2_0 {
      position: absolute;
      width: 192px;
      height: 80px;
      top: 30px;
      left: 290px;
      transform: rotate(-211deg);
      .imgsize12_2 {
        transform: rotate(211deg);
      }
    }
    .dwab12_2_1 {
      position: absolute;
      width: 130px;
      height: 80px;
      top: 95px;
      left: 480px;
      transform: rotate(-211deg);
      .imgsize12_2 {
        transform: rotate(211deg);
      }
    }
    .imgsize12_3 {
      position: absolute;
      top: 390px;
      left: 390px;
    }
    // 老浙北公厕
    .dwab16_0 {
      position: absolute;
      width: 150px;
      height: 80px;
      top: 20px;
      left: 450px;
      transform: rotate(-21deg);
      .imgsize16 {
        transform: rotate(21deg);
      }
    }
    .dwab16_2_0 {
      position: absolute;
      width: 305px;
      height: 80px;
      top: 330px;
      left: 20px;
      transform: rotate(-120deg);
      .imgsize16_2 {
        transform: rotate(120deg);
      }
    }
    .dwab16_2_1 {
      position: absolute;
      width: 190px;
      height: 80px;
      top: 100px;
      left: 160px;
      transform: rotate(-20deg);
      .imgsize16_2 {
        transform: rotate(20deg);
      }
    }
    .imgsize16_3 {
      position: absolute;
      top: 130px;
      left: 680px;
    }
    // 丰虹路公厕
    .dwab17_0 {
      position: absolute;
      width: 355px;
      height: 64px;
      top: 195px;
      left: -10px;
      transform: rotate(-25.4deg);
      .imgsize17 {
        transform: rotate(25.4deg);
      }
    }
    .dwab17_2_0 {
      position: absolute;
      width: 175px;
      height: 64px;
      top: 120px;
      left: 325px;
      transform: rotate(228deg);
      .imgsize17_2 {
        transform: rotate(-228deg);
      }
    }
    .dwab17_2_1 {
      position: absolute;
      width: 250px;
      height: 64px;
      top: 95px;
      left: 440px;
      transform: rotate(224deg);
      .imgsize17_2 {
        transform: rotate(-224deg);
      }
    }
    .imgsize17_3 {
      position: absolute;
      top: 300px;
      left: 690px;
    }
    // 生态博物馆公厕
    .dwab21_0 {
      position: absolute;
      width: 175px;
      height: 80px;
      top: 235px;
      left: 25px;
      transform: rotate(50deg);
      .imgsize21 {
        transform: rotate(-50deg);
      }
    }
    .dwab21_2_0 {
      position: absolute;
      width: 105px;
      height: 80px;
      top: 30px;
      left: 540px;
      transform: rotate(218deg);
      .imgsize21_2 {
        transform: rotate(-218deg);
      }
    }
    .dwab21_2_1 {
      position: absolute;
      width: 180px;
      height: 80px;
      top: 110px;
      left: 300px;
      transform: rotate(42deg);
      .imgsize21_2 {
        transform: rotate(-42deg);
      }
    }
    .imgsize21_3 {
      position: absolute;
      top: 415px;
      left: 235px;
    }
    // 百汇绿岛公厕
    .dwab22_0 {
      position: absolute;
      width: 125px;
      height: 80px;
      top: 35px;
      left: 395px;
      transform: rotate(-20deg);
      .imgsize22 {
        transform: rotate(20deg);
      }
    }
    .dwab22_2_0 {
      position: absolute;
      width: 215px;
      height: 80px;
      top: 260px;
      left: 120px;
      transform: rotate(159deg);
      .imgsize22_2 {
        transform: rotate(-159deg);
      }
    }
    .dwab22_2_1 {
      position: absolute;
      width: 215px;
      height: 80px;
      top: 195px;
      left: 25px;
      transform: rotate(-20deg);
      .imgsize22_2 {
        transform: rotate(20deg);
      }
    }
    .imgsize22_3 {
      position: absolute;
      top: 205px;
      left: 635px;
    }
    // 恒威路公厕
    .dwab23_0 {
      position: absolute;
      width: 50px;
      height: 80px;
      top: 160px;
      left: 235px;
      transform: rotate(42deg);
      .imgsize23 {
        transform: rotate(-42deg);
      }
    }
    .dwab23_1 {
      position: absolute;
      width: 180px;
      height: 80px;
      top: 160px;
      left: 25px;
      transform: rotate(48deg);
      .imgsize23 {
        transform: rotate(-48deg);
      }
    }
    .dwab23_2_0 {
      position: absolute;
      width: 155px;
      height: 80px;
      top: 30px;
      left: 440px;
      transform: rotate(218deg);
      .imgsize23_2 {
        transform: rotate(-218deg);
      }
    }
    .dwab23_2_1 {
      position: absolute;
      width: 180px;
      height: 80px;
      top: 80px;
      left: 255px;
      transform: rotate(42deg);
      .imgsize23_2 {
        transform: rotate(-42deg);
      }
    }
    // 玉馨路公厕
    .dwab25_0 {
      position: absolute;
      width: 225px;
      height: 80px;
      top: 80px;
      left: 260px;
      transform: rotate(42deg);
      .imgsize25 {
        transform: rotate(-42deg);
      }
    }
    .dwab25_2_0 {
      position: absolute;
      width: 225px;
      height: 80px;
      top: 140px;
      left: 180px;
      transform: rotate(220deg);
      .imgsize25_2 {
        transform: rotate(-220deg);
      }
    }
    .imgsize25_3 {
      position: absolute;
      top: 270px;
      left: 340px;
    }
    // 后寨路公厕
    .dwab26_0 {
      position: absolute;
      width: 265px;
      height: 64px;
      top: 200px;
      left: 50px;
      transform: rotate(-138deg);
      .imgsize26 {
        transform: rotate(138deg);
      }
    }
    .dwab26_2_0 {
      position: absolute;
      width: 220px;
      height: 64px;
      top: 100px;
      left: 540px;
      transform: rotate(-20deg);
      .imgsize26_2 {
        transform: rotate(20deg);
      }
    }
    .dwab26_2_1 {
      position: absolute;
      width: 320px;
      height: 64px;
      top: 35px;
      left: 350px;
      transform: rotate(162deg);
      .imgsize26_2 {
        transform: rotate(-162deg);
      }
    }
    // 迎宾大道公厕
    .dwab28_0 {
      position: absolute;
      width: 165px;
      height: 80px;
      top: 170px;
      left: 70px;
      transform: rotate(-138deg);
      .imgsize28 {
        transform: rotate(138deg);
      }
    }
    .dwab28_2_0 {
      position: absolute;
      width: 155px;
      height: 80px;
      top: 55px;
      left: 400px;
      transform: rotate(218deg);
      .imgsize28_2 {
        transform: rotate(-218deg);
      }
    }
    .imgsize28_3 {
      position: absolute;
      top: 310px;
      left: 280px;
    }
    // 龙山公厕
    .dwab30_0 {
      position: absolute;
      width: 205px;
      height: 80px;
      top: 365px;
      left: 55px;
      transform: rotate(50deg);
      .imgsize30 {
        transform: rotate(-50deg);
      }
    }
    .dwab30_2_0 {
      position: absolute;
      width: 135px;
      height: 80px;
      top: 175px;
      left: 440px;
      transform: rotate(154deg);
      .imgsize30_2 {
        transform: rotate(-154deg);
      }
    }
    .imgsize30_3 {
      position: absolute;
      top: 315px;
      left: 400px;
    }
    // 古鄣桥公厕
    .dwab36_0 {
      position: absolute;
      width: 120px;
      height: 80px;
      top: 40px;
      left: 295px;
      transform: rotate(-138deg);
      .imgsize36 {
        transform: rotate(138deg);
      }
    }
    .dwab36_2_0 {
      position: absolute;
      width: 185px;
      height: 80px;
      top: 235px;
      left: 600px;
      transform: rotate(-28deg);
      .imgsize36_2 {
        transform: rotate(28deg);
      }
    }
    .dwab36_2_1 {
      position: absolute;
      width: 185px;
      height: 80px;
      top: 95px;
      left: 505px;
      transform: rotate(152deg);
      .imgsize36_2 {
        transform: rotate(-152deg);
      }
    }
    .imgsize36_3 {
      position: absolute;
      top: 160px;
      left: 70px;
    }
    // 石佛桥南公厕
    .dwab37_0 {
      position: absolute;
      width: 120px;
      height: 80px;
      top: 40px;
      left: 295px;
      transform: rotate(-138deg);
      .imgsize37 {
        transform: rotate(138deg);
      }
    }
    .dwab37_2_0 {
      position: absolute;
      width: 185px;
      height: 80px;
      top: 235px;
      left: 600px;
      transform: rotate(-28deg);
      .imgsize37_2 {
        transform: rotate(28deg);
      }
    }
    .dwab37_2_1 {
      position: absolute;
      width: 185px;
      height: 80px;
      top: 95px;
      left: 505px;
      transform: rotate(152deg);
      .imgsize37_2 {
        transform: rotate(-152deg);
      }
    }
    .imgsize37_3 {
      position: absolute;
      top: 160px;
      left: 70px;
    }
  }

  .paperExtractorStatus {
    position: absolute;
    left: 20px;
    bottom: 20px;
    font-size: 25px;
    z-index: 2060;
    cursor: pointer;

    .paperText {
      padding-left: 10px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/html/toiletOccupy.vue